import React, { Fragment } from 'react'
import { compose } from 'ramda'
import { connectStats, connectCurrentRefinements } from 'react-instantsearch/connectors'
import styled from 'styled-components'
import { Theme } from '@pga/pga-component-library'

import FilterClear from './SearchFilters/FilterClear'
import { getFiltersCount, getFilterText } from './SearchFilters/utils'
import { isRecommended } from './SearchFilters/RecommendedJobsFilter/utils'

const Span = styled.span`
  color: ${Theme.colors.primary};
  font-family: ${Theme.fonts.Montserrat};
  font-weight: ${props => props.fw || '400'};
  padding-left: ${props => props.padding ? '4px' : 0};
  color: ${props => Theme.colors[props.color] || Theme.colors['primary']};
`

export const SearchStats = ({ nbHits, searchState, onSearchStateChange, items: refinedItems, ...props }) => {
  const isRecommendSet = isRecommended(searchState)
  const filtersCount = getFiltersCount(searchState)

  const firstFilterText = isRecommendSet ? 'Recommended Only' : getFilterText(searchState) // recommended jobs text takes precedence over other filters
  const hasFilter = filtersCount > 0
  const hasOneFilter = filtersCount === 1
  const hasMoreThanOneFilter = filtersCount > 1

  return (
    hasFilter ? (
      <div className='pb-3'>
        <Span>
          {nbHits} Results for
        </Span>
        {firstFilterText && <Span fw='600' padding>"{firstFilterText}"</Span>}

        {hasMoreThanOneFilter && (
          <Fragment>
            <Span padding>and</Span>
            <Span fw='600' padding>{filtersCount - 1} more</Span>
            <Span padding>{filtersCount > 2 ? 'filters' : 'filter'}</Span>
          </Fragment>
        )}

        {hasOneFilter && <Span padding>filter</Span>}
        <Span padding>
          <Span>(</Span>
          <Span padding>
            <FilterClear searchState={searchState} onSearchStateChange={onSearchStateChange} text='Clear All' />
          </Span>
          <Span padding>)</Span>

        </Span>
      </div>
    ) : null
  )
}

export default compose(
  connectCurrentRefinements,
  connectStats
)(SearchStats)
